// extracted by mini-css-extract-plugin
export default {"skeletBlock":"SkeletSplitItem_skeletBlock--PtA","skeletShimmer":"SkeletSplitItem_skeletShimmer--ffC","clearRectangle":"SkeletSplitItem_clearRectangle--y_a"};